import { stampSchoolSelection, notifySchoolSelectionUpdated } from './schoolSelectionTtl';

/**
 * Persist the visitor's school / shop / class selection — the ONE shape every
 * reader expects (useSchoolSelection, useMenuItemNavigation, the school popup):
 *   { school: {id, slug, name, classes, seasons}, season: {id, slug, name}|null, class, savedAt }
 * `season` is the chosen SHOP (legacy key name). Stamps the 24h TTL and announces
 * the write to same-tab listeners.
 *
 * @param {string} storageKey e.g. 'clsdk_school_selection'
 */
export function saveSchoolSelection(storageKey, school, season, cls) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(stampSchoolSelection({
      school: {
        id: school.id,
        slug: school.slug,
        name: school.name,
        classes: school.classes,
        seasons: school.seasons,
      },
      season: season ? { id: season.id, slug: season.slug, name: season.name } : null,
      class: cls,
    })));
    notifySchoolSelectionUpdated(storageKey);
  } catch { /* quota exceeded — ignore */ }
}
